"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _floor2 = _interopRequireDefault(require("lodash/floor"));
var _reactRouterDom = require("react-router-dom");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _DeploymentPlayer = _interopRequireDefault(require("../../../../DeploymentPlayer"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Boilerplate = window.cccisd.boilerplate;
var RepeatedFinalTest = function RepeatedFinalTest(_ref) {
  var actingPawnHash = _ref.actingPawnHash,
    actingPawnId = _ref.actingPawnId,
    completedMessage = _ref.completedMessage,
    latestFinalTestData = _ref.latestFinalTestData,
    isPreviewMode = _ref.isPreviewMode,
    language = _ref.language,
    lockedMessage = _ref.lockedMessage,
    onComplete = _ref.onComplete,
    onCompleteLocation = _ref.onCompleteLocation,
    relatedDeploymentId = _ref.relatedDeploymentId,
    settings = _ref.settings;
  var history = (0, _reactRouterDom.useHistory)();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    finalTestDeploymentId = _useState2[0],
    setFinalTestDeploymentId = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showResults = _useState4[0],
    setShowResults = _useState4[1];

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE //////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    getFinalTestDeploymentId();
  }, []);
  function getFinalTestDeploymentId() {
    return _getFinalTestDeploymentId.apply(this, arguments);
  }
  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */
  function _getFinalTestDeploymentId() {
    _getFinalTestDeploymentId = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var response, responseDeploymentId;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            if (!isPreviewMode) {
              _context3.n = 1;
              break;
            }
            setFinalTestDeploymentId(settings.parentDeploymentId);
            return _context3.a(2);
          case 1:
            _context3.n = 2;
            return _cccisdAxios["default"].get(Boilerplate.route('api.assignmentDeployment.repeated', {
              deploymentId: settings.parentDeploymentId,
              hash: actingPawnHash,
              pawnId: actingPawnId
            }), {
              params: {
                isPawnHash: true,
                relatedDeploymentId: relatedDeploymentId
              }
            });
          case 2:
            response = _context3.v;
            responseDeploymentId = (0, _get2["default"])(response, 'data.data.deploymentId');
            if (responseDeploymentId) {
              setFinalTestDeploymentId(responseDeploymentId);
            } else {
              console.error('Repeat deployment not found');
            }
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _getFinalTestDeploymentId.apply(this, arguments);
  }
  if (completedMessage && !showResults) {
    return /*#__PURE__*/_react["default"].createElement("div", null, completedMessage);
  }
  if (lockedMessage) {
    return /*#__PURE__*/_react["default"].createElement("div", null, lockedMessage);
  }
  var onCompleteLocal = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!onComplete) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return onComplete();
          case 1:
            setShowResults(true);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onCompleteLocal() {
      return _ref2.apply(this, arguments);
    };
  }();
  if (!finalTestDeploymentId) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  var componentProps = {
    deploymentId: parseInt(finalTestDeploymentId, 10),
    disableLayout: true,
    isPreviewMode: isPreviewMode,
    language: language,
    onComplete: onCompleteLocal,
    pawnHash: actingPawnHash,
    pawnId: actingPawnId
  };
  if (showResults && (0, _get2["default"])(latestFinalTestData, 'assignmentProgress.completed')) {
    var scoreDetail = latestFinalTestData.numTotal ? "".concat(latestFinalTestData.numCorrect, " out of ").concat(latestFinalTestData.numTotal, " correct") : '';
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].scoreCard
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].scoreCardPreHeader, latestFinalTestData.passing ? _style["default"].backgroundPass : _style["default"].backgroundFail)
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].scoreCardHeader
    }, "Your score"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].scoreCardBody
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].scoreCardScoreContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].scoreCardScore
    }, (0, _floor2["default"])(latestFinalTestData.score), "%"), scoreDetail), !latestFinalTestData.passing && !latestFinalTestData.exceededMaxTries && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].marginTop, _style["default"].failFeedback)
    }, "You must score at least ", settings.passingThreshold, "% to proceed."), !latestFinalTestData.passing && latestFinalTestData.exceededMaxTries && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].marginTop, _style["default"].failFeedback)
    }, settings.maxTriesMessage || "You have not correctly answered ".concat(settings.passingThreshold, "% of the questions after ").concat(settings.maxTries, " attempts. Please click Continue to revisit the module content. After you review at least one lesson, you can click the Module Final Test tab to retake the test.")), onCompleteLocation && latestFinalTestData.passing && !latestFinalTestData.exceededMaxTries && /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _classnames["default"])('btn', _style["default"].marginTop, _style["default"].passBtn),
      type: "button",
      onClick: function onClick() {
        return history.push(onCompleteLocation);
      }
    }, "Continue"), onCompleteLocation && !latestFinalTestData.passing && latestFinalTestData.exceededMaxTries && /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _classnames["default"])('btn', _style["default"].marginTop, _style["default"].passBtn),
      type: "button",
      onClick: function onClick() {
        return history.push(onCompleteLocation);
      }
    }, "Continue"), !latestFinalTestData.passing && !latestFinalTestData.exceededMaxTries && /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _classnames["default"])('btn', _style["default"].marginTop, _style["default"].failBtn),
      type: "button",
      onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getFinalTestDeploymentId();
            case 1:
              setShowResults(false);
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))
    }, "Try Again"))), settings.showFinalTestFeedback && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].finalTestFeedbackContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].finalTestFeedbackHeader
    }, "Review your answers"), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].finalTestFeedbackBody, _style["default"].marginTop)
    }, /*#__PURE__*/_react["default"].createElement(_DeploymentPlayer["default"], _extends({}, componentProps, {
      isFinalTestMode: true
    })))));
  }
  return /*#__PURE__*/_react["default"].createElement(_DeploymentPlayer["default"], componentProps);
};
RepeatedFinalTest.propTypes = {
  actingPawnHash: _propTypes["default"].string,
  actingPawnId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  completedMessage: _propTypes["default"].string,
  latestFinalTestData: _propTypes["default"].object,
  isPreviewMode: _propTypes["default"].bool,
  language: _propTypes["default"].string,
  lockedMessage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  onComplete: _propTypes["default"].func,
  onCompleteLocation: _propTypes["default"].string,
  relatedDeploymentId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  settings: _propTypes["default"].object
};
var _default = exports["default"] = RepeatedFinalTest;